import routes from './routes';
import store from './store';

export default {
  routes: routes,
  store: store
}